


















import Vue from 'vue'
import CoreBase from '@corets/base'
import Base from '@custom/base'

export default Vue.extend({
    name: 'NSearchPanel',
    mixins: [CoreBase, Base],
    props: {
        customClass: {
            type: String,
            default: ''
        },
        moreNum: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            isShrink: true
        }
    },
    methods: {
        shrink () {
            const self = this
            self.isShrink = !self.isShrink
        },
        reset () {
            const self = this
            self.$emit('reset')
        },
        search () {
            const self = this
            self.$emit('search')
        }
    }
})
